import { IUserSettings } from "models";
import { ActionTypes } from "./actions";

export const userSettingsReducer = (state: IUserSettings, { payload, type }: { payload: any, type: ActionTypes } ) => {
    switch (type) {
		case ActionTypes.ApiGetUserSettings:
			return payload;
			
        default:
            return state
    }
}


